<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded">
    <br />
    <div class="col-12 col-md-6 wet-signature">
      <!--  <h4>Congratulations {{ entityDetails ? entityDetails.entityName : '' }} your application has been approved.</h4> -->
      <h4>Congratulations! Now that your credit application has been approved, you need to review and sign the lease documentation.</h4>
      <p v-if="isUserPrimaryApplicant">How to proceed:</p>
      <ol v-if="isUserPrimaryApplicant">
        <li>Email or download the below documents straight to your device.</li>
        <li>Print and sign documents along with any other signatories required.</li>
        <li>Once completed, please log back in and upload the signed documents.</li>
      </ol>
      <p v-if="!isUserPrimaryApplicant">Please continue to view and sign the lease agreement.</p>
    </div>

    <div class="col-12 col-md-6 wet-signature" v-if="isUserPrimaryApplicant">
      <div class="toggle_section" v-bind:class="!enableWetSign ? 'inactive' : ''">
        <div class="toggle_header" v-on:click="enableWetSign = !enableWetSign">
          <img
            v-bind:src="enableWetSign ? '/assets/icons/open.svg' : '/assets/icons/closed.svg'"
            v-bind:class="enableWetSign ? 'open' : 'closed'"
          />
          <h5>Lease Documents</h5>
        </div>
        <div class="toggle_content" v-if="enableWetSign">
          <DocumentDownload
            text="Personal Guarantee"
            wetSignatureObjName="documentPCA"
            :loadingDownloadProp="loadingDocumentPCADownload"
            :loadingSendEmailProp="loadingDocumentPCASendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            :enableDisable="enableDisableWSMix"
          ></DocumentDownload>
        </div>
      </div>
      <div class="toggle_section" v-bind:class="!enableWetUpload ? 'inactive' : ''">
        <div class="toggle_header" v-on:click="enableWetUpload = !enableWetUpload">
          <img
            v-bind:src="enableWetUpload ? '/assets/icons/open.svg' : '/assets/icons/closed.svg'"
            v-bind:class="enableWetUpload ? 'open' : 'closed'"
          />
          <h5>Upload Signed Document</h5>
        </div>
        <div class="toggle_content" v-if="enableWetUpload">
          <DocumentUpload
            text="Personal Guarantee"
            wetSignatureObjName="documentPCA"
            @onClickDelete="onClickDeleteWSMix"
            :loadingDeleteProp="loadingDocumentPCADelete"
            :applicationId="vehicleApplication ? vehicleApplication.applicationId : ''"
            :isSubmitted="false"
          ></DocumentUpload>
        </div>
      </div>
      <div class="toggle_section" v-bind:class="!enableDigitalSign ? 'inactive' : ''" v-if="isFileUploaded">
        <div class="toggle_header" v-on:click="enableDigitalSign = !enableDigitalSign">
          <img
            v-bind:src="enableDigitalSign ? '/assets/icons/open.svg' : '/assets/icons/closed.svg'"
            v-bind:class="enableDigitalSign ? 'open' : 'closed'"
          />
          <h5>Contract Documents</h5>
        </div>
        <div class="toggle_content" v-if="enableDigitalSign">
          <DigitalModule />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 wet-signature" v-else>
      <DigitalModule />
    </div>

    <br />
    <br />
    <div class="q-px-lg q-py-lg" style="text-align: center">
      <QBtn color="primary" outline no-caps @click="onClickHandler()">Log Out</QBtn>
    </div>
  </div>
</template>

<script>
import { QBtn } from 'quasar';
import { mapState, mapGetters } from 'vuex';
import DigitalModule from '@/pages/ReviewAndSignContract/DigitalModule';
import DocumentDownload from '@/components/Atoms/DocumentDownload';
import DocumentUpload from '@/components/Atoms/DocumentUpload';
import WetSignatureMixins from '@/mixins/WetSignatureMixins.js';

export default {
  name: 'CalculatorCombination',
  components: { QBtn, DigitalModule, DocumentDownload, DocumentUpload },
  props: [],
  mixins: [WetSignatureMixins],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      vehicleApplication: (state) => state.vehicleApplication.vehicleApplication
    }),
    ...mapGetters({
      isUserPrimaryApplicant: 'vehicleApplication/isUserPrimaryApplicant'
    }),
    isFileUploaded() {
      if (
        this.scoreboard &&
        this.scoreboard.wetSignature &&
        this.scoreboard.wetSignature.documentPCA &&
        this.scoreboard.wetSignature.documentPCA.uploadFile &&
        this.scoreboard.wetSignature.documentPCA.uploadFile.uuid
      )
        return true;
      else return false;
    },
    entityDetails() {
      return this.scoreboard?.entityDetails ? this.scoreboard?.entityDetails : null;
    }
  },
  created() {},
  data: function () {
    return {
      enableDigitalSign: true,
      enableWetSign: true,
      enableWetUpload: true
    };
  },
  methods: {
    onClickHandler: function () {
      this.$router.push({ name: 'logout' });
    }
  }
};
</script>
